import React, { useEffect } from "react";
import { Tooltip } from "react-bootstrap";

// 文字列変更時に表示幅を自動更新するTooltip
// eslint-disable-next-line react/display-name
const FlexibleTooltip = React.forwardRef(({ popper, children, ...otherProps }, ref) => {
  useEffect(() => {
    popper.scheduleUpdate();
  }, [children, popper]);
  return (<Tooltip ref={ref} {...otherProps}>{children}</Tooltip>);
});

export default FlexibleTooltip;